export default "__VITE_ASSET__d48aa6e5__"